
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.162 0a1.2 1.2 0 00-1.2 1.2v8.416h22.225L23.066.001 12.162 0M34 12.162c0-.664-.533-1.199-1.2-1.199h-8.412v22.232l9.608-10.129L34 12.162M21.84 34a1.2 1.2 0 001.198-1.202v-8.413H.812l10.123 9.613L21.84 34M0 21.84c0 .663.537 1.203 1.202 1.203h8.41V.81L.002 10.935 0 21.84","fill":"#117ACA"}})])
          )
        }
      }
    